import { useNavigate } from "react-router-dom";
import "./TagCard.css";
import { Tag } from "effno-core";

type TagCardProps = {
    tag: Tag;
    allowClick?: boolean;
}

export const TagCard = ({tag, allowClick = true}: TagCardProps) => {

    const navigate = useNavigate();
    
    return (
        <div 
            className={allowClick ? "tag-card" : "tag-card-disabled"}
            style={{cursor: allowClick ? "pointer" : "default"}}
            onClick={()=> {if (allowClick) {navigate("/home/" + tag.id)} }}
        >
            {tag.name}
        </div>
    )
}